import http from "../http-common";

class FastQuotingDoorVersionDataService {
  getAll(condition) {
    return http.get(`/fastquotingdoorversions/search/?fastquotingdoorId=${condition}`);
  }

  getfastquotingdoorversionsByDescr(condition,fastquotingdoorversionnumber,sortfield,sorttype) {
    return http.get(`/fastquotingdoorversions/search/?fastquotingdoorId=${condition}&fastquotingdoorversionnumber=${fastquotingdoorversionnumber}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }  

  getCondition(condition) {
    return http.get(`/fastquotingdoorversions/search/?fastquotingdoorversion=${condition}`);
  }

  get(id) {
    return http.get(`/fastquotingdoorversions/${id}`);
  }

  findById(id) {
    return http.get(`/fastquotingdoorversions/${id}`);
  }  

  create(data) {
    return http.post("/fastquotingdoorversions", data);
  }

  update(id, data) {
    return http.put(`/fastquotingdoorversions/update/${id}`, data);
  }

  delete(id) {
    return http.delete(`/fastquotingdoorversions/${id}`);
  }

  deletewhere(id) {
    return http.delete(`/fastquotingdoorversions/where/${id}`);
  }  

  deleteAll() {
    return http.delete(`/fastquotingdoorversions/items`);
  }


//////////////////////////////////////////////////////////////////////////////////////////////////////////////

}

export default new FastQuotingDoorVersionDataService();
